import { ProvisionDisplayDetails } from "../../types";
import "./SkuProvisionSummary.scss";

interface SkuProvisionSummaryProps {
  details: ProvisionDisplayDetails;
}

const SkuProvisionSummary = ({ details }: SkuProvisionSummaryProps) => (
  <dl className="sku-provision-summary">
    <div>
      <dt>Order</dt>
      <dd>{details.order}</dd>
    </div>
    <div>
      <dt>SKU</dt>
      <dd>{details.sku}</dd>
    </div>
    <div>
      <dt>Type</dt>
      <dd>{details.skuType}</dd>
    </div>
    <div>
      <dt>Interval</dt>
      <dd>{details.interval}</dd>
    </div>
  </dl>
);

export default SkuProvisionSummary;
